import React from 'react';
import { motion } from 'framer-motion';
const TESTIMONIALS = [{
  quote: 'Sheets2Board completely eliminated our VLOOKUP hell. Our ops team builds complex models in minutes just by typing what they want.',
  name: 'Sarah Chen',
  role: 'Head of Ops',
  company: 'Acme Corp',
  initials: 'SC',
  color: 'bg-blue-500'
}, {
  quote: "The ability to turn a raw CSV export into a beautiful, shareable dashboard instantly feels like magic. It's replaced three other tools for us.",
  name: 'Marcus Johnson',
  role: 'Data Analyst',
  company: 'Global Tech',
  initials: 'MJ',
  color: 'bg-emerald-500'
}, {
  quote: 'Finally, a spreadsheet that understands intent. The AI data cleaning alone saves me 5 hours a week formatting messy CRM data.',
  name: 'Elena Rodriguez',
  role: 'RevOps Manager',
  company: 'Scale Inc',
  initials: 'ER',
  color: 'bg-purple-500'
}];
export function Testimonials() {
  return <section className="py-24 border-t border-white/5" data-id="element-212">
      <div className="max-w-7xl mx-auto px-6" data-id="element-213">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-214">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="p-6 rounded-2xl bg-zinc-900/30 border border-white/10 flex flex-col" data-id="element-215">
              <div className="flex-1 mb-6" data-id="element-216">
                <p className="text-zinc-300 leading-relaxed" data-id="element-217">"{t.quote}"</p>
              </div>
              <div className="flex items-center gap-3" data-id="element-218">
                <div className={`w-10 h-10 rounded-full ${t.color} flex items-center justify-center text-sm font-bold text-white`} data-id="element-219">
                  {t.initials}
                </div>
                <div data-id="element-220">
                  <div className="text-sm font-medium text-white" data-id="element-221">{t.name}</div>
                  <div className="text-xs text-zinc-500" data-id="element-222">
                    {t.role}, {t.company}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}